module.exports = __webpack_public_path__ + "static/img/logo47.264977a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo47.png
// module id = KJ+E
// module chunks = 1